export default __webpack_public_path__ + "92b03b197089e5b57405ad76b2ac2053.png";